import { styled } from 'styled-components';

const SelectInputWrapper = styled.div`
  .ant-select-single.ant-select-show-arrow .ant-select-selection-item,
  .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
    padding-right: 12px;
  }
  .ant-select-arrow {
    right: 7px;
  }
  .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
    padding: 0;
  }
  .ant-input-number-input {
    height: 26px;
  }
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 26px;
    padding: 0;
  }
  .ant-select-single .ant-select-selector .ant-select-selection-item,
  .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    line-height: 24px;
  }
  .ant-select-item {
    padding: 5px 0;
  }
`;

export default SelectInputWrapper;
